import { Salad, Zap, Sprout, HeartHandshake, Award, Repeat, TrendingUp, Users, Phone, ClipboardList, MessagesSquare, LucideProps } from "lucide-react";

const MAP = { salad: Salad, zap: Zap, sprout: Sprout, heart: HeartHandshake, award: Award, repeat: Repeat, trend: TrendingUp, users: Users, phone: Phone, clipboard: ClipboardList, chat: MessagesSquare };

export function Icon({ name, ...props }: { name: string } & LucideProps) {
  const C = MAP[name as keyof typeof MAP] ?? Sprout;
  return <C strokeWidth={1.4} {...props} />;
}
